/**
 * @desc lodash merge hack
 */
import * as lodash from './lodash';
export var lodashMergeCustomer = function (value, srcValue) {
    if (lodash.isArray(value) && lodash.isArray(srcValue) && value.length > srcValue.length) {
        return lodash.mergeWith(value.slice(0, srcValue.length), srcValue, lodashMergeCustomer);
    }
};
export default function merge(object) {
    var sourceList = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sourceList[_i - 1] = arguments[_i];
    }
    return sourceList.reduce(function (prev, current) { return lodash.mergeWith(prev, current, lodashMergeCustomer); }, object);
}
